<div class="tarificacion-container">
    <div class="tarificacion-total">
        {{ this.recibo?.reciboAnualidad?.importeTotal || this.recibo?.reciboPrimerPago?.importeTotal || 0 | currency:'EUR':'symbol':'1.2-2' }}
        <button ca-button-icon type="button" (click)="abrirModal()">
            <ca-icon>add_circle</ca-icon>
        </button>
    </div>
    <div class="tarificacion-detalle">
        <p>{{'COMUN.DATOS_ECONOMICOS.PRIMER_PAGO' | translate}} : <strong>{{ recibo.reciboPrimerPago?.importeTotal || 0 | currency:'EUR':'symbol':'1.2-2' }}</strong></p>
        <div *ngIf="recibo.reciboPagosSucesivos?.importeTotal">
            <p>{{'COMUN.DATOS_ECONOMICOS.RESTO_PAGOS' | translate}}: <strong>{{ recibo.reciboPagosSucesivos?.importeTotal || 0 | currency:'EUR':'symbol':'1.2-2' }}</strong></p>
        </div>
    </div>
    <button ca-button class="ca-btn-icon__container" (click)="contratar()">
        {{'MENU.PRIVADO.CONTRATAR' | translate}}
    </button>
</div>

